import React, { useState, useEffect } from 'react';

export default function NavigationMenu() {
  const sections = {
    about: "About",
    projects: 'Projects',
    contacts: 'Contact me'
  }
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6
    };

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    Object.keys(sections).forEach(id => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  });

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <ul className="menu">
      {Object.keys(sections).map((key) => (
        <li
          key={key}
          className={`${activeSection === key ? "active" : ""}`}
          onClick={() => scrollToSection(key)}
        >
          {sections[key]}
        </li>
      ))}
    </ul>
  );
}